import { FILTER_QUERY_PARAMS } from 'client/site-modules/shared/constants/lease-deals/lease-deals';
import { srpLinkBuilder } from 'client/site-modules/shared/utils/srp-link-constructor';

export function createSrpUrl(selectedFilters = {}) {
  const excludedFilters = [
    FILTER_QUERY_PARAMS.MONTHLY_PAYMENT,
    FILTER_QUERY_PARAMS.DUE_AT_SIGNING,
    FILTER_QUERY_PARAMS.SORT_BY,
    FILTER_QUERY_PARAMS.PAGE_NUM,
    FILTER_QUERY_PARAMS.DEALS,
  ];

  const baseParams = {
    paymenttype: 'lease',
    inventorytype: 'new',
  };

  const queryParams = Object.entries(selectedFilters).reduce((acc, [key, value]) => {
    if (!excludedFilters.includes(key) && value?.length > 0) {
      acc[key] = value.join(',');
    }

    return acc;
  }, baseParams);

  return srpLinkBuilder(queryParams);
}
